import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import Image from "components/image";
import PageGallery from "components/pagegallery";
import husbandryImg from "img/boaconstrictors/Boa Constrictors.png";
import collectionMeta from "content/collections/boa-constrictors.json";
import { animalGridFromJson } from "hooks/useGallery";

const animalGridData = animalGridFromJson(collectionMeta);

const BoaConstrictor = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Boa Constrictors (Boa imperator)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/boa-constrictors" />
      </Helmet>

      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />

      <AnimalGrid data={animalGridData} />

      <BodyText>
        I've always wanted boa constrictors and  I started with a pair of Sharp 
        albinos - Crush and Blizzard - but I also love the VPI T+ Albino gene so 
        I have a pair of boas that are VPI T+ as well. 
        I want to say that's enough boas but have you seen
        a VPI T+ IMG Aztec? Soooo hot!
      </BodyText>

      <h1>Husbandry</h1>

      <Image
        src={husbandryImg}
      />
      
      <BodyText>
        <h3>Temperatures, Humidity, and Light</h3>
        <p>
          Colombian boa husbandry is relatively straightforward. I keep my boas in the 
          mid-80s°F during the day for most of the year, allowing temperatures to drop 
          into the mid- to upper 70s°F at night.
        </p>
        <p>
          The climate where I live in the U.S. is quite dry, so maintaining appropriate 
          humidity requires a little extra effort. I aim for a humidity range of approximately 
          50–70%, which has worked well for my animals. I use large water bowls positioned 
          beneath the radiant heat panels along one side of each enclosure to encourage evaporation. 
          I also provide about 4 inches of coconut bark substrate, which I lightly dampen once or 
          twice a week. Together, these measures help maintain suitable humidity levels without 
          requiring constant misting.
        </p>
      </BodyText>

      <BodyText>
        <h3>Feeding</h3>
        As shown in the chart, I feed my adult Boa imperator every 3–4 weeks throughout 
        the year. These boas can be surprisingly easy to overfeed, which can lead to 
        obesity and other health issues. A good rule of thumb is to maintain a healthy 
        body condition, with a cross-sectional shape resembling a loaf of bread—rounded 
        but not overly wide or bulging. Adjust prey size and feeding frequency as needed 
        to keep your boa in good condition.
      </BodyText>

      <BodyText>
        <h3>Breeding</h3>
        <p>
          Back in the early 90s a guy in a pet store told me that breeding boa 
          constrictors was next to impossible. So I didn't even think I'd give 
          it a try. But now that I have a better idea how to keep and breed snakes
          generally, I've found that either they aren't that tricky or I have had
          some beginner's luck.
        </p>
        <p>
          As the chart shows, for breeding, I drop the daytime and nighttime temperatures by
          about 6-8 degrees for 3 months of the year - Nov, Dec, and Jan. There
          is also a month on each side of that cool-down which I use to gradually lower 
          or raise the temps. 
        </p>
        <p>
          I cut the light down to just 8 hours a day during that time and I pair
          the males and females togther. You can see that I manipulate their food
          a bit before and during the breeding period. In August and September I 
          feed both the males and females more food than they were getting during
          the rest of the year. Then in October and November I shrink the food item
          down to something small.
        </p>
        <p>
          I was successful doing everything that I described in the paragraphs before this
          one, but as you can see in the chart, I am considering a change to adopt a
          practice that Jeff Ronne uses, which is to continue feeding the male and the
          female occasionally during the rest of the breeding period from Dec - Feb. 
          I'll give it a try and update the chart accordingly.
        </p>
      </BodyText>

      <PageGallery slug="boa-constrictors" maxWidth="900" />
    </ContentBox>
  );
};

export default BoaConstrictor;
